module.exports = __webpack_public_path__ + "img/preview.72ddb9f6.webp";